import React  from 'react';
import { Form, Field } from 'react-final-form'
import FieldContainer from '../../../shared/containers/form/FieldContainer';
import { SendButton } from '../../../shared/components/Buttons';
import { validate } from '../../../../data/followup/validators/instant_message';
import {withTranslation} from "react-i18next";
import cx from "classnames"
import {ChatBubbleLeftEllipsisIcon, UserCircleIcon} from "@heroicons/react/20/solid";

const InstantMessageForm = ({ handleSubmit, initialValues, t }) => {
    return <li>
        <div className="relative pb-8">
            <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
            <div className="relative flex items-start space-x-3">
                <div>
                    <div className="relative px-1">
                        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                            <UserCircleIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                            <span className="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
                                <ChatBubbleLeftEllipsisIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="min-w-0 flex-1 py-1.5">
                    <div className="text-sm text-gray-500">
                        <Form onSubmit={handleSubmit} validate={validate} initialValues={initialValues}>
                            {({ handleSubmit, pristine, form, submitting , invalid}) =>
                                <form onSubmit={e => {
                                    handleSubmit(e).then(()=>{
                                        form.reset(initialValues)
                                    })
                                }} className="send-message-form flex flex-row">
                                    <FieldContainer form="instant_message" name="message" className="form-group">
                                        <Field id="message"
                                               name="message"
                                               className="border-none, text-gray-600 block w-full rounded-md border-gray-300 text-sm shadow-sm focus:border-orange-500 focus:ring-orange-500"
                                               component="textarea"
                                               placeholder={t('followup.write_message')} rows="4" />
                                    </FieldContainer>

                                    <SendButton
                                        type="submit"
                                        size="medium"
                                        className={cx("border-orange-700 text-white rounded p-3 ml-1", {
                                            'bg-orange-800 hover:cursor-not-allowed': pristine || submitting || invalid,
                                            'bg-orange-500': !(pristine || submitting || invalid),
                                        })}
                                        disabled={pristine || submitting || invalid}
                                        loading={submitting}
                                    />
                                </form>}
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </li>
    }
;

export default withTranslation()(InstantMessageForm);
